module.exports = __webpack_public_path__ + "static/media/M.6bfd6afe.jpg";